(function () {
  var MAX_ATTEMPTS = 20;
  var RETRY_DELAY_MS = 150;

  function getReshowFunction() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      return function () {
        window.privacyBanner.showPreferences();
      };
    }
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.showPreferences === 'function'
    ) {
      return function () {
        window.Shopify.customerPrivacy.showPreferences();
      };
    }
    return null;
  }

  function waitForReshowFunction(onReady, onTimeout, attemptsLeft) {
    var reshow = getReshowFunction();
    if (reshow) {
      onReady(reshow);
      return;
    }
    if (attemptsLeft <= 0) {
      onTimeout();
      return;
    }
    setTimeout(function () {
      waitForReshowFunction(onReady, onTimeout, attemptsLeft - 1);
    }, RETRY_DELAY_MS);
  }

  function setStatus(button, message) {
    var statusEl = document.getElementById(button.getAttribute('aria-describedby'));
    if (statusEl) {
      statusEl.textContent = message;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cookie-preferences-trigger]');
    if (!button) return;

    event.preventDefault();
    button.disabled = true;
    setStatus(button, '');

    waitForReshowFunction(
      function (reshow) {
        button.disabled = false;
        reshow();
      },
      function () {
        button.disabled = false;
        setStatus(
          button,
          'Cookie-Einstellungen konnten nicht geladen werden. Bitte die Seite neu laden und erneut versuchen.'
        );
      },
      MAX_ATTEMPTS
    );
  });
})();
